import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';

@Injectable()
export class InFlightRequestInterceptor implements HttpInterceptor {
  private inFlightRequests = new Map<string, Observable<HttpEvent<any>>>();

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const requestKey = this.getRequestKey(req);

    // If same request already exists → return same observable
    if (this.inFlightRequests.has(requestKey)) {
      return this.inFlightRequests.get(requestKey)!;
    }

    const request$ = next.handle(req).pipe(
      shareReplay(1), // cache response until completed
      tap({
        complete: () => this.inFlightRequests.delete(requestKey),
        error: () => this.inFlightRequests.delete(requestKey),
      })
    );

    this.inFlightRequests.set(requestKey, request$);
    return request$;
  }

  private getRequestKey(req: HttpRequest<any>): string {
    return `${req.method}:${req.urlWithParams}:${JSON.stringify(
      req.body || {}
    )}`;
  }
}
